module.exports = __webpack_public_path__ + "img/p4b__success_icon.eddea978.svg";